<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.WaiLakeWahakari"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.WaiLakeMorehurehu"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.WaiLakeWaihopo"></app-basic-cartesian-chart>
